import { useEffect, useRef, useState } from 'react';

interface AdaptiveCaptureProviderProps {
  setPhoto: any;
  getPhoto: any;
}
const AdaptiveCaptureProvider = ({
  setPhoto,
  getPhoto,
}: AdaptiveCaptureProviderProps) => {
  const localPhoto = useRef<any>('');

  useEffect(() => {
    const imgSrc = getPhoto();
    if (!imgSrc?.length || imgSrc?.length < 10) {
      console.error('Empty Data taken');
      setTimeout(() => {
        const imgSrc = getPhoto();
        localPhoto.current = imgSrc;
      }, 2000);
    }
    localPhoto.current = imgSrc;
    let timer = setInterval(() => {
      const imgSrc = getPhoto();
      if (!imgSrc?.length || imgSrc?.length < 10) {
        console.error('Empty Data taken');
      }
      localPhoto.current = imgSrc;
    }, 15000);
    return () => clearInterval(timer);
  }, [getPhoto]);

  useEffect(() => {
    return () => {
      setPhoto(localPhoto.current);
    };
  }, []);

  return <></>;
};

export default AdaptiveCaptureProvider;
